import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography, TextField, Box, Avatar, Paper, IconButton, AvatarGroup, Button, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import toast from 'react-hot-toast';
import LeadService from '../../../core/services/leadsService';
import logo_between from '../../../../public/assets/logo-white.jpeg';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import logoIcon from '../../../../public/assets/Convrt_bg_remover.png';
import icoonectICA from '../../../../public/assets/icoonectICA.png';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import VideoAudioCall from '../AudioVideoCall/VideoAudioCall';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
const ChatUI = () => {
    const theme = useTheme();
    const userData = JSON.parse(localStorage.getItem('user'));
    const LoginUserID = userData?.user?.id;
    const userId = userData?.user?.id;
    const [getChat, setGetChat] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [chatId, setChatId] = useState(null);
    const [logOutModal, setLogOutModal] = useState(false);
    const [ChatDetails, setChatDetails] = useState('');
    const [messages, setMessages] = useState([]);
    const [zoomLevel, setZoomLevel] = useState(13);
    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const userLocalData = JSON.parse(localStorage.getItem('user'));
    const LoginUserProfileImage = userData?.user?.profile_image;

    const GetAllChatIca = async (LoginUserID) => {
        try {
            setLoadingData(true);
            setChatId(null);
            setChatDetails(' ');
            const res = await LeadService.getIcaAllChat(LoginUserID);
            if (res?.data?.success) {
                // Sort by the latest timestamp in descending order (newest first)
                const sortedChats = res.data.leadChat.sort((a, b) => new Date(b.lead.chat.timestamp) - new Date(a.lead.chat.timestamp));
                setGetChat(sortedChats);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoadingData(false);
        }
    };

    useEffect(() => {
        GetAllChatIca(LoginUserID);
    }, []);

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const GetAllChatIcaDetails = async (chatId) => {
        try {
            setLoading(true);
            setChatId(chatId);
            const res = await LeadService.getIcaAllChatDetails(chatId);
            if (res?.data?.success) {
                setChatDetails(res?.data?.lead);
                getChats(chatId);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };

        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(ChatDetails?.status);
    const handleZoomIn = () => {
        setZoomLevel((prevZoom) => prevZoom + 1);
    };

    const handleZoomOut = () => {
        setZoomLevel((prevZoom) => Math.max(1, prevZoom - 1));
    };
    const getChats = async (chatId) => {
        try {
            const res = await LeadService.getIsaChat(chatId);
            if (res.data.success) {
                setMessages(res.data.leadDetails || []);
            } else {
                setMessages([]);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        }
    };

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (chatId) {
                getChats(chatId);
            }
        }, 3000); // Call every 3 seconds

        return () => clearInterval(intervalId);
    }, [chatId]);

    const sendMessage = async (event) => {
        event.preventDefault();
        if (!newMessage.trim()) return;

        const nextMessage = {
            lead_id: chatId,
            message: newMessage,
            timestamp: new Date(),
            content_type: 'text',
            sender_id: userId, // Add the sender_id explicitly
        };

        try {
            const res = await LeadService.addIsainternalchat(nextMessage);
            if (res?.data?.success) {
                // Update the `getChat` state with the latest message at the top
                setGetChat((prevChat) => {
                    const updatedChatList = [...prevChat];
                    // Find the index of the chat being updated
                    const chatIndex = updatedChatList.findIndex((chat) => chat.lead_id === chatId);
                    if (chatIndex !== -1) {
                        // Update the existing chat with the new message and timestamp
                        updatedChatList[chatIndex].lead.chat = nextMessage;
                    } else {
                        // If this is a new chat, add it to the array
                        updatedChatList.push({ lead: { chat: nextMessage }, lead_id: chatId });
                    }
                    // Sort the chats by the latest message timestamp, with the newest on top
                    return updatedChatList.sort((a, b) => new Date(b.lead.chat.timestamp) - new Date(a.lead.chat.timestamp));
                });
            }
        } catch (error) {
            // Handle the error gracefully if the message could not be sent
            toast.error('Message could not be sent. Please try again.');
        } finally {
            setNewMessage('');
        }
    };

    const messagesEndRef = useRef(null);
    const prevMessageCountRef = useRef(messages.length);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    useEffect(() => {
        if (messages.length > prevMessageCountRef.current) {
            scrollToBottom();
        }
        prevMessageCountRef.current = messages.length;
    }, [messages]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Filter getChat based on search term
    const filteredChats = getChat?.filter((chat) => {
        const assigneeName = `${chat?.assignto?.name || ''} ${chat?.assignto?.last_name || ''}`.toLowerCase();
        const leadName = `${chat?.lead?.first_name || ''} ${chat?.lead?.last_name || ''}`.toLowerCase();
        const term = searchTerm.toLowerCase();
        // Check if either the assignee's or lead's name includes the search term
        return assigneeName.includes(term) || leadName.includes(term);
    });

    const lead_id = ChatDetails?.id;
    const caller_id = ChatDetails.assignby?.id;
    const receiver_ids = [ChatDetails.assignto?.id, ChatDetails.customer?.id].filter((id) => id !== undefined);

    return (
        <>
            {loadingData ? (
                <Box style={{ display: 'flex', justifyContent: 'center', top: '45%', position: 'relative' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <ThemeProvider theme={theme}>
                        <GlobalStyles
                            styles={{
                                '::-webkit-scrollbar': {
                                    width: '10px', // Set the desired width for the scrollbar
                                },
                                '::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                    borderRadius: '10px', // Set the border radius for a rounded effect
                                },
                            }}
                        />
                        <Grid
                            container
                            sx={{
                                backgroundColor: '#f5f5f5',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            {/* Sidebar */}
                            <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3}
                                sx={{
                                    borderRight: '1px solid #ddd',
                                    height: '100vh',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                    boxShadow: { xs: 'none', sm: '2px 0px 5px rgba(0, 0, 0, 0.1)' },
                                }}
                            >
                                <Box style={{ padding: '5px', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}>
                                    <div>
                                        {/* <Paper
                                        component="form"
                                        sx={{
                                            width: { sx: 270, sm: 290, md: 340, lg: 340 },
                                            background: '#F0F4F8',
                                        }}
                                    >
                                        <IconButton type="button" aria-label="search">
                                            <SearchIcon />
                                        </IconButton>
                                        <InputBase
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            inputProps={{ 'aria-label': 'search google maps' }}
                                        />
                                    </Paper> */}
                                    </div>
                                    <div>
                                        <Tooltip title="Refresh ICA Chat">
                                            <RefreshIcon style={{ fontSize: '28px' }} onClick={() => GetAllChatIca(LoginUserID)} />
                                        </Tooltip>
                                    </div>
                                </Box>
                                <Box sx={{ padding: 2 }}>
                                    {filteredChats && filteredChats.length > 0 ? (
                                        filteredChats?.map((chat) => {
                                            const userOffset = getUserOffset();
                                            const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(chat?.lead?.chat?.timestamp, userOffset);
                                            const formattedDate = formatDateTime(adjustedDate);
                                            const SelectedID = ChatDetails.id;
                                            const truncateMessage = (text) => {
                                                if (text && text.length > 21) {
                                                    return text.substring(0, 21) + '...';
                                                }
                                                return text;
                                            };
                                            const truncateAddress = (text) => {
                                                if (text && text.length > 33) {
                                                    return text.substring(0, 33) + '...';
                                                }
                                                return text;
                                            };
                                            return (
                                                <Paper
                                                    key={chat?.id}
                                                    onClick={() => GetAllChatIcaDetails(chat?.lead_id)}
                                                    sx={{
                                                        padding: 1.5,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginBottom: 1,
                                                        cursor: 'pointer',
                                                        borderRadius: '10px',
                                                        transition: 'background-color 0.3s',
                                                        '&:hover': {
                                                            backgroundColor: chat?.lead_id === SelectedID ? '#77b4ef' : '#e0e9f1',
                                                        },
                                                        background: chat?.lead_id === SelectedID ? '#77b4ef' : '',
                                                        gap: '5px',
                                                    }}
                                                    elevation={1}
                                                >
                                                    <AvatarGroup max={4}>
                                                        <Avatar
                                                            sx={{
                                                                width: { xs: 20, sm: 30, lg: 40 },
                                                                height: { xs: 20, sm: 30, lg: 40 },
                                                            }}
                                                            src={`https://iconnctapp.com/${chat?.assignto?.profile_image}`}
                                                        />
                                                        <Avatar
                                                            sx={{
                                                                width: { xs: 20, sm: 30, lg: 40 },
                                                                height: { xs: 20, sm: 30, lg: 40 },
                                                            }}
                                                            src={`https://iconnctapp.com/${chat?.assignby?.profile_image}`}
                                                        />
                                                    </AvatarGroup>
                                                    <Box>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 500,
                                                                fontSize: { md: '14px' },
                                                                width: '200px',
                                                            }}
                                                        >
                                                            {[
                                                                `${chat?.assignto?.name || ''} ${chat?.assignto?.last_name || ''}`.trim(),
                                                                `${chat?.lead?.first_name || ''} ${chat?.lead?.last_name || ''}`.trim(),
                                                            ]
                                                                .filter(Boolean)
                                                                .join(', ')}
                                                        </Typography>

                                                        <Typography
                                                            variant="body2"
                                                            color="textSecondary"
                                                            sx={{
                                                                width: '250px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            {truncateMessage(chat?.lead?.chat?.message)}
                                                        </Typography>
                                                        <Box style={{ display: 'flex', marginTop: '4px' }}>
                                                            <Typography style={{ fontSize: '11px' }}>
                                                                📍{truncateAddress(chat?.lead?.display_address)}
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '60px' }}>
                                                            <Typography style={{ fontSize: '11px' }}>{formattedDate}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            );
                                        })
                                    ) : (
                                        <Typography variant="body1" color="textSecondary" align="center" sx={{ marginTop: 2 }}>
                                            No chats found.
                                        </Typography>
                                    )}
                                </Box>
                            </Grid>

                            {/* Chat Area */}
                            {chatId === null && (
                                <Grid item xs={12} sm={8} md={9}>
                                    <Box item style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Avatar src={logoIcon} alt=" " style={{ width: '270px', height: '270px' }} />
                                    </Box>
                                    <Box item style={{ display: 'flex', justifyContent: 'center' }}>
                                        <img src={icoonectICA} alt=" " />
                                    </Box>
                                    <Box item style={{ display: 'flex', justifyContent: 'center', marginTop: '22px', padding: '12px' }}>
                                        <Typography>
                                            Please click on any group chat, review the past conversations, and initiate communication with both the agent
                                            and the customer.
                                        </Typography>
                                    </Box>
                                </Grid>
                            )}
                            {chatId && (
                                <Grid item xs={12} sm={8} md={9}>
                                    {/* Sticky Header */}
                                    <Box
                                        sx={{
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 1000,
                                            backgroundColor: '#fff',
                                            padding: '16px',
                                            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                                            borderBottom: '1px solid #ddd',
                                        }}
                                    >
                                        {/* Google Image */}
                                        <Box
                                            sx={{
                                                position: 'relative',
                                                marginBottom: '16px',
                                                borderRadius: '10px',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            <img
                                                src={`https://maps.googleapis.com/maps/api/staticmap?zoom=${zoomLevel}&size=571x170&maptype=roadmap&center=${ChatDetails?.buyer_latitude},${ChatDetails?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                alt="Static map"
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                }}
                                            />
                                            <Button
                                                onClick={handleZoomIn}
                                                sx={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '50px',
                                                    backgroundColor: '#fff',
                                                    minWidth: '32px',
                                                    minHeight: '32px',
                                                }}
                                            >
                                                <AddIcon />
                                            </Button>
                                            <Button
                                                onClick={handleZoomOut}
                                                sx={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    backgroundColor: '#fff',
                                                    minWidth: '32px',
                                                    minHeight: '32px',
                                                }}
                                            >
                                                <RemoveIcon />
                                            </Button>
                                            <Box
                                                style={{
                                                    position: 'absolute',
                                                    top: '40%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    borderRadius: '4px',
                                                    padding: '5px',
                                                }}
                                            >
                                                <img
                                                    src={logo_between}
                                                    alt=""
                                                    style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }}
                                                />
                                            </Box>
                                        </Box>

                                        {/* User Details */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                                                {ChatDetails?.first_name} {ChatDetails?.last_name}
                                            </Typography>

                                            <Box>
                                                <div style={{ display: 'flex', marginBottom: '15px' }}>
                                                    <VideoAudioCall lead_id={lead_id} caller_id={caller_id} receiver_ids={receiver_ids} />
                                                </div>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    style={{
                                                        ...divStyle,
                                                        borderRadius: '10px',
                                                        padding: '3px',
                                                        width: 'auto',
                                                        display: 'flex',
                                                        gap: '2px',
                                                        marginRight: '0px',
                                                    }}
                                                >
                                                    {formattedStatus}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Chat Section */}
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            // height: 'calc(100vh - 450px)',
                                            height: '56vh ',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        {/* Chat Messages */}
                                        <Box
                                            sx={{
                                                // flexGrow: 1,
                                                // padding: 2,
                                                // overflowY: 'auto',
                                                // backgroundColor: '#f9f9f9',
                                                flexGrow: 1,
                                                padding: 2,
                                                overflowY: 'auto', // This enables scrolling for the messages container
                                                height: '400px', // Set a fixed or relative height to constrain the scrollable area
                                                backgroundColor: '#f9f9f9',
                                            }}
                                        >
                                            {messages?.map((message, index) => {
                                                const timestamp = message?.timestamp; // Assuming this is a string in ISO format
                                                let formattedDateTime = '';
                                                if (timestamp) {
                                                    const date = new Date(timestamp); // Construct Date directly from the timestamp
                                                    const day = date.getDate().toString().padStart(2, '0');
                                                    const monthIndex = date.getMonth();
                                                    const year = date.getFullYear();
                                                    const monthNames = [
                                                        'Jan',
                                                        'Feb',
                                                        'Mar',
                                                        'Apr',
                                                        'May',
                                                        'Jun',
                                                        'Jul',
                                                        'Aug',
                                                        'Sep',
                                                        'Oct',
                                                        'Nov',
                                                        'Dec',
                                                    ];
                                                    const formattedDate = `${day} ${monthNames[monthIndex]} ${year}`;
                                                    let hours = date.getHours();
                                                    const minutes = date.getMinutes().toString().padStart(2, '0');
                                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                                    hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
                                                    const formattedTime = `${hours}:${minutes} ${ampm}`;
                                                    formattedDateTime = `${formattedDate}, ${formattedTime}`;
                                                }
                                                return (
                                                    <Box
                                                        key={message.id}
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: message?.sender_id === userId ? 'row-reverse' : 'row',
                                                            alignItems: 'center',
                                                            marginBottom: 2,
                                                        }}
                                                    >
                                                        {/* <Avatar
                                                src={`https://iconnctapp.com/` + LoginUserProfileImage}
                                                    sx={{
                                                        marginLeft: message?.sender_id === userId ? 2 : 0,
                                                        marginRight: message?.sender_id === userId ? 0 : 2,
                                                    }}
                                                /> */}
                                                        <Paper
                                                            sx={{
                                                                padding: 1.5,
                                                                backgroundColor: message?.sender_id === userId ? '#e0e7ff' : '#bbdefb',
                                                                borderRadius: '15px',
                                                                maxWidth: '70%',
                                                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                <Avatar
                                                                    src={message?.sender_id === userId
                                                                        ? `https://iconnctapp.com/${LoginUserProfileImage}`
                                                                        : `https://iconnctapp.com/${ChatDetails?.assignto?.profile_image}`}
                                                                    sx={{
                                                                    }}
                                                                />
                                                                <Typography variant="body2" sx={{ fontSize: '0.95rem', color: '#333' }}>
                                                                    {message?.message}
                                                                </Typography>
                                                            </div>

                                                            <Typography variant="caption" display="block" color="textSecondary" align="right">
                                                                {/* {message?.timestamp || null || ''} */}
                                                                {formattedDateTime}
                                                            </Typography>
                                                        </Paper>
                                                    </Box>
                                                );
                                            })}
                                            <div ref={messagesEndRef} />
                                        </Box>

                                        {/* Input Section */}
                                        <Box
                                            sx={{
                                                padding: 2,
                                                borderTop: '1px solid #ddd',
                                                display: 'flex',
                                                alignItems: 'center',
                                                backgroundColor: '#fff',
                                            }}
                                        >
                                            <form onSubmit={sendMessage} style={{ display: 'flex', flex: 1 }}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    placeholder="Enter text here"
                                                    value={newMessage}
                                                    onChange={(e) => setNewMessage(e.target.value)}
                                                    sx={{
                                                        backgroundColor: '#f9f9f9',
                                                        borderRadius: '20px',
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '1px 16px',
                                                        },
                                                        marginRight: 1,
                                                    }}
                                                />
                                                <IconButton
                                                    color="primary"
                                                    type="submit"
                                                    style={{
                                                        backgroundColor: '#1976d2',
                                                        color: '#fff',
                                                        borderRadius: '18%',
                                                    }}
                                                >
                                                    <SendIcon />
                                                </IconButton>
                                            </form>
                                        </Box>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </ThemeProvider>
                </>
            )}
        </>
    );
};

export default ChatUI;
